module.exports = __webpack_public_path__ + "img/Wp_2042.4083aa28.png";